/**
 * The type of playlist
 */
export enum PlaylistType {
  /**
   * A pattern of sounds made by musical instruments, voices, or computers, or a combination of these, intended to give pleasure to people listening to it.
   */
  Music = 'music',

  /**
   * A film shown in a cinema or on television and often telling a story.
   */
  Movies = 'movies',

  /**
   * A form of entertainment, originally from Japan, in which recordings of the music but not the words of popular songs are played, so that people can sing the words themselves.
   */
  Karaoke = 'karaoke',
}
